import React, { useState, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import AuthContext from "../contexts/AuthContext";
import BookInsurranceForm from "../components/BookInsurranceForm";
import MainLayout from "../layouts/MainLayout";

import { getAuthenticatedUser as getAuthUser } from "../apis";

function Booking() {
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");

  const insurranceName = useParams().slug.replace("-", " ").toUpperCase();

  const auth = useContext(AuthContext);

  //   Function to get the current authenticated user
  const onGetAuthUser = async () => {
    const json = await getAuthUser(auth.token);

    if (json) {
      setUserName(json.name);
      setUserEmail(json.email);
    }
  };

  useEffect(() => {
    onGetAuthUser();
  }, []);

  return (
    <MainLayout pageCSS={"booking-page"}>
      <BookInsurranceForm
        token={auth.token}
        name={userName}
        email={userEmail}
        insurranceName={insurranceName}
      />
    </MainLayout>
  );
}

export default Booking;
